/* eslint-disable no-restricted-syntax */
import queryString from 'query-string';

export function getQueryParams(obj) {
  return queryString.parse(obj, {parseBooleans: true});
}

export const getQueryString = (obj) => {
  const str = [];
  for (const p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  return str.join('&');
};
